"use client";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { ProjectDetails } from "@/app/projects/[project]/page";

const CarouselImage = ({ image }: { image: ProjectDetails }) => {
  return (
    <Link
      href={`projects/${image.name.replace(/\s+/g, "").toLowerCase()}`}
      className="flex flex-col items-center pb-8 self-baseline focus:outline-none focus-visible:ring focus-visible:ring-olive focus-visible:underline hover:underline hover:shadow-custom-top-sides px-0 w-full text-left group"
    >
      <figure>
        <Image
          src={image.images[0].image}
          alt={image.images[0].alt}
          className="object-cover w-[30rem] h-[30rem]"
          width={500}
          height={500}
        />
        <figcaption className="text-xl">{image.name}</figcaption>
      </figure>
    </Link>
  );
};

export default function Carousel({ projects }: { projects: ProjectDetails[] }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const items = projects;
  if (!items) return null;

  // Function to move to the next item
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  // Function to move to the previous item
  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + items.length) % items.length
    );
  };

  return (
    <div className="relative w-full flex flex-col justify-center items-center">
      {/* Carousel Items */}
      <div className="overflow-hidden w-full">
        <div
          className="flex transition-transform duration-500"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {items?.map((item, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-full px-4 pt-8 flex justify-center"
            >
              <CarouselImage image={item as ProjectDetails} />
            </div>
          ))}
        </div>
      </div>
      <div className="flex">
        <button
          className="top-1/2 left-4 transform -translate-y-1/2 mr-2 bg-olive text-white p-2 sm:p-1 md:p-2 lg:p-3 rounded-full"
          onClick={handlePrev}
        >
          &#8592;
        </button>
        {/* Right Arrow */}
        <button
          className=" top-1/2 right-4 transform -translate-y-1/2 bg-olive text-white p-2 sm:p-1 md:p-2 lg:p-3 rounded-full"
          onClick={handleNext}
        >
          &#8594;
        </button>
      </div>
    </div>
  );
}
